import React from 'react';

// Components
import { ErrorMessage } from './ErrorMessage';
import Tooltip from './Tooltip';
import InfoIcon from './InfoIcon';

interface Props {
  label?: string;
  name: string;
  value?: string;
  defaultValue?: string;
  errorMessage?: string;
  placeholder?: string;
  tooltipContent?: JSX.Element;
  autoComplete?:
    | 'off'
    | 'on'
    | 'name'
    | 'email'
    | 'username'
    | 'street-address'
    | 'country-name'
    | 'postal-code'
    | 'tel';
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const InputText: React.FC<Props> = ({
  label,
  name,
  value,
  defaultValue,
  placeholder,
  tooltipContent,
  errorMessage,
  onChange,
  onBlur,
  autoComplete = 'on',
}) => {
  return (
    <div className="membership-app__choice membership-app__choice--text">
      <div className="membership-app__choice-container">
        {label && (
          <label className='form-label' htmlFor={`text-input-${name}`}>
            <span>{label}</span>
            {tooltipContent && (
              <Tooltip
                content={tooltipContent}
                trigger={
                  <span tabIndex={0} className='membership-app__choice-info'>
                    <InfoIcon size="sm" />
                  </span>
                }
              />
            )}
          </label>
        )}
        <input
          className={`form-control ${errorMessage ? 'form-control--error' : ''} `}
          type={'text'}
          id={`text-input-${name}`}
          name={name}
          value={value}
          maxLength={300}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onBlur={onBlur}
          onChange={onChange}
          autoComplete={autoComplete}
        />
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    </div>
  );
};
